import './instrumentation';

/* TODO switch from redirectUrl to onComplete callback */
// import {
//   createOnFormComplete,
//   OnFormCompleteFn,
// } from '@axo/site/components/Products/onFormComplete/create-on-form-complete';
// import { LocationAdapter } from '@axo/site/components/Products/onFormComplete/location.adapter';
import { ConfigService } from '@axo/config/ConfigService';
import type { FormProps } from '@axo/form/feature/axo-form-v2/lib/types';
import { createFormDefaultValues } from '@axo/site/components/Products/formDefaultValues/create-form-default-values';
import { createRedirectTo } from '@axo/site/utils/create-redirect-to';
import React, { type ComponentType } from 'react';
import { createRoot } from 'react-dom/client';
import {
  WhiteLabelWrapper,
  type WhiteLabelWrapperOptions,
} from './WhiteLabelWrapper.v2';

type ViewProps = FormProps & {
  baseUrl: string;
  redirectUrl: string;
  isWL?: boolean;
  /* TODO switch from redirectUrl to onComplete callback */
  // onCompleted?: OnFormCompleteFn;
};

export type MountOptions = WhiteLabelWrapperOptions & {
  type: 'pre' | 'main';
  View: ComponentType<ViewProps>;
  viewProps?: ViewProps;
};

export const mount = async ({
  type,
  View,
  viewProps,
  ...options
}: MountOptions) => {
  const scriptId = 'axo-script';
  const divId = 'axo-root-v2';
  const scriptElement = document.getElementById(scriptId);
  let root = null;

  if (!scriptElement)
    throw new Error(`Could not mount: script with id "${scriptId}" not found.`);

  if (scriptElement?.parentNode) {
    const generatedDivElement = document.createElement('div');
    generatedDivElement.id = divId;
    scriptElement.parentNode.insertBefore(generatedDivElement, scriptElement);
    root = createRoot(generatedDivElement);
  }

  ConfigService.initialize(options.brand, [
    'global',
    'site',
    'product-unsecured-loan',
    'product-credit-card',
  ]);

  const baseUrl = viewProps?.baseUrl
    ? viewProps.baseUrl
    : import.meta.env.VITE_API_URL;
  const redirectUrl = viewProps?.redirectUrl
    ? viewProps?.redirectUrl
    : type === 'main'
    ? createRedirectTo({ product: 'my-page' })
    : createRedirectTo({ product: 'unsecured-loan' });
  const { amount, duration } = createFormDefaultValues();

  console.log('mounting', { brand: options.brand, redirectUrl });

  /* TODO switch from redirectUrl to onComplete callback */
  // const onFormComplete = createOnFormComplete({
  //   destinationUrl: redirectUrl,
  //   navigationAdapter: useLocationAdapter,
  // });

  root?.render(
    <React.StrictMode>
      <WhiteLabelWrapper {...options}>
        <View
          baseUrl={baseUrl}
          redirectUrl={redirectUrl}
          /* TODO switch from redirectUrl to onComplete callback */
          // onCompleted={onFormComplete}
          isWL={true}
          options={{
            defaultLoanAmount: amount,
            defaultLoanDuration: duration,
          }}
          hasCard={viewProps?.hasCard}
        />
      </WhiteLabelWrapper>
    </React.StrictMode>
  );
};
